<div class="summary-table" [class.summary-table--border]="hasBorder">
  <ng-content></ng-content>
</div>
